var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogleSheet = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.8838 5.53033L12.8839 5.53034C13.1183 5.76477 13.25 6.08271 13.25 6.41421V13C13.25 13.6904 12.6904 14.25 12 14.25H4C3.30964 14.25 2.75 13.6904 2.75 13V3C2.75 2.30964 3.30964 1.75 4 1.75H8.58579C8.91731 1.75 9.23525 1.88169 9.46966 2.11611L12.8838 5.53033ZM9 2.35354V2.25H8.5H4C3.58579 2.25 3.25 2.58579 3.25 3V13C3.25 13.4143 3.58583 13.75 4 13.75H12C12.4142 13.75 12.75 13.4142 12.75 13V6.5V6H12.6464L11.7929 5.14645L9.85356 3.20711L9 2.35354Z",
  fill: "#4C5773",
  stroke: "#4C5773"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 1.25C3.0335 1.25 2.25 2.0335 2.25 3V13C2.25 13.9665 3.0335 14.75 4 14.75H12C12.9665 14.75 13.75 13.9665 13.75 13V6.41421C13.75 5.95008 13.5656 5.50497 13.2374 5.17678L9.82322 1.76256C9.49503 1.43437 9.04992 1.25 8.58579 1.25H4Z",
  fill: "#26A668"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.7003 6.00012H9.5C9.22386 6.00012 9 5.77626 9 5.50012V1.2998C9.30909 1.37511 9.59454 1.53397 9.82322 1.76265L13.2374 5.17686C13.4661 5.40555 13.625 5.69101 13.7003 6.00012Z",
  fill: "#92D3B4"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.5 8.5H10.5V9.5H5.5V8.5ZM9.5 10.5H5.5V11.5H9.5V10.5Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleSheet);
export default ForwardRef;